module.exports = __webpack_public_path__ + "img/icon-layout-table.73ba9b50.svg";